import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";

export const IconChevronLeftSmall: React.FC<CentralIconBaseProps> = (props) => {
  return <CentralIconBase {...props} ariaLabel="chevron-left-small"><path fillRule="evenodd" clipRule="evenodd" d="M14.3233 7.46967C14.0304 7.17678 13.5555 7.17678 13.2626 7.46967L9.61619 11.1161C9.12804 11.6043 9.12804 12.3957 9.61619 12.8839L13.2626 16.5303C13.5555 16.8232 14.0304 16.8232 14.3233 16.5303C14.6162 16.2374 14.6162 15.7626 14.3233 15.4697L10.8536 12L14.3233 8.53033C14.6162 8.23744 14.6162 7.76256 14.3233 7.46967Z" fill="currentColor"/></CentralIconBase>;
};

export default IconChevronLeftSmall;
